import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const GeneralFields: React.FC<{
  selectedKey: string;
  setSelectedKey: (v: string) => void;
  formData: any;
  setFormData: (v: any) => void;
  jsonValid: boolean;
  setJsonValid: (v: boolean) => void;
}> = ({ selectedKey, setSelectedKey, formData, setFormData, jsonValid, setJsonValid }) => {
  const { t } = useTranslation();

  const handleJSONChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    try {
      const parsedValue = JSON.parse(value);
      setFormData(parsedValue);
      setJsonValid(true);
    } catch (err) {
      setJsonValid(false);
    }
  };

  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId="generalKey">
        <Form.Label column sm="2">
          {t('key')}
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="key" value={selectedKey} onChange={(e) => setSelectedKey(e.target.value)} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="generalValue">
        <Form.Label column sm="2">
          {t('value')}
        </Form.Label>
        <Col sm="10">
          <Form.Control
            as="textarea"
            rows={5}
            name="json"
            placeholder="Enter JSON object"
            onChange={handleJSONChange}
            isInvalid={!jsonValid}
            defaultValue={JSON.stringify(formData, null, 2)}
          />
          <Form.Text className={jsonValid ? 'text-success' : 'text-danger'}>
            {jsonValid ? (
              <>
                <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                {t('valid')} JSON {t('format')}
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                {t('invalid')} JSON {t('format')}
              </>
            )}
          </Form.Text>
        </Col>
      </Form.Group>
    </>
  );
};

export default GeneralFields;
